<template>
  <div class="TranProgramActivity-view-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-button class="btn ml-3" type="button" @click="returnPage">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
          </span>
          Trở về trước
        </b-button>
        <b-button
          class="btn btn-inactive ml-3"
          type="button"
          v-if="tranProgramActivityData.isActive && isDeletePermission"
          @click="handleInactive(tranProgramActivityData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Inactive
        </b-button>
        <b-button
          class="btn btn-active ml-3"
          type="button"
          v-if="!tranProgramActivityData.isActive && isDeletePermission"
          @click="handleInactive(tranProgramActivityData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Active
        </b-button>
        <b-button
          class="btn btn-success ml-3"
          type="button"
          v-if="isDeletePermission"
          @click.stop="handleUpdate(tranProgramActivityData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/edit-2.svg" />
          </span>
          Chỉnh sửa
        </b-button>
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="TranProgramActivity-view-page__body mb-6 mt-6">
        <b-row Class="mt-8">
          <b-col>
            <div class="text-muted">Mã:</div>
            <div>
              {{ tranProgramActivityData.code }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">Tên hoạt động:</div>
            <div>
              {{ tranProgramActivityData.name }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">Loại hoạt động:</div>
            <div>
              {{ tranProgramActivityData.activityTypeId }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">Ngày tạo:</div>
            <div>
              {{
                convertTimestampToDate(tranProgramActivityData.createDatetime)
              }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">Ngày chỉnh sửa:</div>
            <div>
              {{
                convertTimestampToDate(tranProgramActivityData.updateDatetime)
              }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">Người tạo:</div>
            <div>
              {{ tranProgramActivityData.creatorName }}
            </div>
          </b-col>

          <b-col>
            <div class="text-muted">Người chỉnh sửa:</div>
            <div>
              {{ tranProgramActivityData.updaterName }}
            </div>
          </b-col>

          <b-col>
            <div class="text-muted">DetailLink:</div>
            <div>
              {{ tranProgramActivityData.detailLink }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">RedirecLink:</div>
            <div>
              {{ tranProgramActivityData.redirectranLink }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">Số lần nhắc nhở:</div>
            <div>
              {{ tranProgramActivityData.reminderNumbers }}
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { convertTimestampToDate } from '../../../core/mixins';
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    setupData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      isFirstLoad: false,
      TranProgramActivityData: {},
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    isDeletePermission() {
      let roles = this.currentUser?.roles;
      if (roles && roles.length) {
        return roles.includes('Admin');
      } else {
        return false;
      }
    },
  },
  methods: {
    convertTimestampToDate,
    returnPage() {
      this.$router.push({
        name: 'tran_program_activity_list',
      });
    },
    handleUpdate(item) {
      this.$router.push({
        name: 'tranProgramActivity_detail',
        params: {
          form_type: 'edit',
          id: item.id,
        },
      });
    },
    handleInactive(item) {
      let text = item.isActive ? 'Inactive' : 'Active';
      let btn = item.isActive ? 'btn-inactive' : 'btn-active';
      this.$swal({
        title: '',
        text: `Bạn có chắc muốn ${text} app user ${item.id} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `${text}`,
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.inactiveItem(item)
              .then(() => {
                this.loadTranProgramActivityData();
                this.$swal(
                  'Thành công!',
                  'Chúc mừng, bạn đã cập nhật thông tin TranProgramActivity thành công!',
                  'success',
                );
              })
              .catch(() => {
                this.$swal('Lỗi!', 'Đã có lỗi xảy ra.', 'error');
              });
          }
        }.bind(this),
      );
    },
    async getCreateandUpdateUser(id) {
      const { data } = await this.$api.get(`/Account?id=${id}`);
      let name = data[0].fullName;
      return name;
    },
    async inactiveItem(item) {
      this.loading = true;
      try {
        let payload = new FormData();
        payload.append('id', item.id);
        payload.append('active', !item.isActive);
        await this.$api.put(`TranProgramActivity`, payload);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },

    async loadTranProgramActivityData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`TranProgramActivity/${id}`);
        const creator = await this.getCreateandUpdateUser(data.creatorId);
        const updater = await this.getCreateandUpdateUser(data.updaterId);

        this.tranProgramActivityData = {
          ...data,
          creatorName: creator,
          updaterName: updater,
        };
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loadTranProgramActivityData();
  },
};
</script>
